document.addEventListener('DOMContentLoaded', function () {
const formEl = document.querySelector("#contact-form");
$(".success-message").hide();
formEl.addEventListener("submit", (event) => {
    event.preventDefault();
  let formJson = {
    request: {
      requester: {
        name: $("#contact-form-email").val(),
        email: $("#contact-form-email").val(),
      },
      subject: $("#contact-form-subject").val(),
      comment: { body: $("#contact-form-message").val() },
    },
  };

  var apiEndpoint = 'https://yankeekicks.zendesk.com/api/v2/requests.json';

    $.ajax({
      type: 'POST',
      url: apiEndpoint,
      dataType: 'json',
      data: formJson,
      success: function(data) {
        // $('#register-customer-form form').submit(); // submit the form after API call is completed
        console.error('Data :', data);
        setTimeout(function() { $(".success-message").show(); }, 1000);
        $('#contact-form')[0].reset();
         return
     
        // handle API response here
      },
      error: function(jqXHR, textStatus, errorThrown) {
        //$('#register-customer-form form').submit(); // submit the form after API call is completed
        console.error('API error:', textStatus, errorThrown);
        // handle API error here
      }
    });
});
});
